import { query } from '@kk/utils';

interface RowData {
    tradingSourceIdentifier: string;
    styleDetail: {
        defaultShowTabConfig: Array<{
            activeTime: Array<number>;
            defaultShowTab: number;
        }>;
        filters: Array<{
            timeLimit: boolean;
            timeRange: Array<number>;
            type: number;
        }>;
    };
}

export function defaultActive(rowData: RowData, now: number) {
    let activeTabIndex: number;
    // 通过在url添加参数 tab_模块id=第几个tab 控制优先显示tab页，如?tab_496_1_34=1   从1开始不从0开始，是为了降低运营搞错概率
    const tabIndex = Number(query.get(`tab_${rowData.tradingSourceIdentifier}`)) - 1;

    // 后台设置的规定时间段内默认展示
    const { defaultShowTabConfig } = rowData.styleDetail;
    let defaultShowTab: number | null = null;
    if (defaultShowTabConfig && defaultShowTabConfig.length) {
        // 根据后台配置显示当前默认tab
        const currentTime = now;
        for (const config of defaultShowTabConfig) {
            const start = new Date(config.activeTime[0]).getTime();
            const end = new Date(config.activeTime[1]).getTime();
            if (currentTime >= start && currentTime < end) {
                defaultShowTab = config.defaultShowTab;
            }
        }
    }

    if (!isNaN(tabIndex) && tabValidator(rowData.styleDetail.filters[tabIndex])) {
        // 根据url query显示当前默认tab
        activeTabIndex = tabIndex;
    } else if (typeof defaultShowTab === 'number') {
        activeTabIndex = defaultShowTab;
    } else {
        activeTabIndex = rowData.styleDetail.filters.findIndex((tabInfo) => tabValidator(tabInfo));
    }

    if (activeTabIndex >= 0) {
        // 有可以激活的tab
        return {
            id: rowData.tradingSourceIdentifier, // 模块id
            activeIndex: activeTabIndex, // 激活的tab
        };
    }
    return null;
}

function tabValidator(tabInfo: { timeLimit: boolean; timeRange: Array<number>; type: number }) {
    if (!tabInfo) return false;
    if (tabInfo.timeLimit) {
        // 有时间范围
        const now = new Date();
        const before = new Date(tabInfo.timeRange[0]);
        const after = new Date(tabInfo.timeRange[1]);
        if (now.valueOf() < before.valueOf()) {
            // 未开始
            return false;
        } else if (now.valueOf() > after.valueOf()) {
            // 已结束
            return false;
        } else {
            if (tabInfo.type === 1) {
                // 关联模块
                return true;
            }
        }
    } else {
        // 没有时间范围
        if (tabInfo.type === 1) {
            // 关联模块
            return true;
        }
    }
    return false;
}
